module.exports = __webpack_public_path__ + "img/archive (1).e69e84a8.png";